import env from '@beam-australia/react-env';
import AccessTokenProvider from '@pkg/auth/AccessTokenProvider';
import AuthObserver from '@pkg/auth/Observer';
import BroadcastProvider from '@pkg/broadcasting/echo/Provider';
import ClientProvider from '@pkg/client/Provider';
import DatabaseProvider from '@pkg/database/Provider';
import DesignsObserver from '@pkg/entities/designs/Observer';
import LibraryObserver from '@pkg/entities/library/Observer';
import QueryProvider from '@pkg/graphql/Provider';
import UserProvider from '@/lib/accounts/users/UserProvider';
import config from '@/lib/config';
import StyleProvider from '@/lib/theme/Provider';
import { CopilotProvider } from '@/components/Copilot/context/CopilotContext';
import AppErrorBoundary from '../AppErrorBoundary/AppErrorBoundary';
import Middleware from '../Middleware';
import AuthenticationProvider from './Authentication';
import IntercomProvider from './Intercom';
import Listener from './Listener';
import SnackbarProvider from './Snackbar';

const AppProviders = ({ skipProviders, ...props }) => {
  if (skipProviders) {
    return props.children;
  }

  return (
    <DatabaseProvider>
      <AuthenticationProvider>
        <StyleProvider>
          <AccessTokenProvider>
            <BroadcastProvider
              cluster={config.PUSHER_CLUSTER}
              apiKey={env('PUSHER_APP_KEY')}
              host={env('API_HOST')}
            >
              <SnackbarProvider>
                <ClientProvider host={env('API_HOST')}>
                  <QueryProvider>
                    <AuthObserver />
                    <AppErrorBoundary>
                      <Middleware>
                        <UserProvider>
                          <Listener />
                          <LibraryObserver>
                            <DesignsObserver>
                              <CopilotProvider>
                                <IntercomProvider {...props} />
                              </CopilotProvider>
                            </DesignsObserver>
                          </LibraryObserver>
                        </UserProvider>
                      </Middleware>
                    </AppErrorBoundary>
                  </QueryProvider>
                </ClientProvider>
              </SnackbarProvider>
            </BroadcastProvider>
          </AccessTokenProvider>
        </StyleProvider>
      </AuthenticationProvider>
    </DatabaseProvider>
  );
};

export default AppProviders;
